export const AZUL = '#003366';
export const LARANJA = '#FF6600';
export const VERDE = '#1a5e3a';
export const ROXO = '#3d1a6e';
export const BRANCO = '#FFFFFF';
export const CINZA = '#f4f4f2';
export const VERDE_WPP = '#25D366';